import { BillUser, GmdUserInfo } from '../../types';
import {
  ClientRate_ItemFragmentFragment,
  GetServicesQuery,
  GetTransactionServiceQuery,
  ServiceBill,
} from '../../__generated__/graphql';
import { Params } from 'react-router-dom';
import { makeVar } from '@apollo/client';

export type SearchActionType = (searchItems: ServiceSearchIndex[]) => void;
export type SearchIndexType = 'SERVICE_NUMBER' | 'CUSTOMER_NUMBER';

export type ServiceSearchIndex = {
  data: string;
  merchant: string;
  serviceId: number;
  dataType: SearchIndexType;
};

export type SearchActionMap = {
  searchBills: SearchActionType;
  searchProducts: SearchActionType;
  searchSubscriptions: SearchActionType;
};

export type ServiceFormProps = {
  user: GmdUserInfo;
  serviceData: GetTransactionServiceQuery | undefined;
  params: Readonly<Params<string>>;
  language: string;
  searchAction: SearchActionType;
  loading?: boolean;
  contractNumber?: string;
  rates: ClientRate_ItemFragmentFragment[];
  serviceBills?: ServiceBill[];
  payor?: BillUser;
  payee?: BillUser;
};

export type ServicableItemProps = {
  contractNumber: string;
  serviceBill: ServiceBill;
  serviceData: GetTransactionServiceQuery | undefined;
  rates: ClientRate_ItemFragmentFragment[];
  payor?: BillUser;
  payee?: BillUser;
};

export type BillsParam = {
  merchant: string;
  serviceId: number;
  serviceNumber?: string;
};

export type ServiceListProps = {
  query: GetServicesQuery;
  loading?: boolean;
  searchText: string;
};

export interface ServiceMetaData {
  dataForm: string;
  displayName: string;
  active: boolean;
  icon: JSX.Element;
}

export const serviceParams = makeVar<BillsParam | null>(null);
